document.addEventListener("DOMContentLoaded", async () => {
    const anchorEl = document.querySelectorAll(".handle-anchor");
    if (anchorEl) {
        const { initAnchorLink } = await import("../components/anchorlink.js");
        initAnchorLink(false);
    }
    const matchHeightEl = document.querySelector("[data-mh]");
    if (matchHeightEl) {
        const { matchHeight } = await import("../components/match-height.js");
        matchHeight(false);
    }
    const handleAccordion = document.querySelectorAll(".handle-accordion");
        if (handleAccordion.length > 0) {
            const { initAccordionHoverControl } = await import('../components/accordion.js');
            initAccordionHoverControl();
                let timeout;
                window.addEventListener("resize", function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => {
                        initAccordionHoverControl();
                    }, 300);
                });

        }
    const popupEl = document.querySelector(".popup-detail");
    if (popupEl) {
        const { openPopup } = await import("../components/modal.js");
        openPopup();
    }

    const scrollHintElements = document.querySelectorAll(".js-scroll-hint");
    if (scrollHintElements.length > 0) {
        const { initScrollHint } = await import("../components/scroll-hint.js");
        initScrollHint();
    }

    const stickyTableElements = document.querySelectorAll(".js-sticky-table");
    if (stickyTableElements.length > 0) {
        const { initStickyTable } = await import("../components/sticky-table.js");
        initStickyTable();
    }

    const { disableContextImage } = await import("../components/detect-image.js");
    disableContextImage("#news-list");
});
